"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _react = _interopRequireWildcard(require("react"));
var _logrocket = _interopRequireDefault(require("logrocket"));
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _PreviewScreen = require("./PreviewScreen");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      error: null,
      errorInfo: null,
      isErrorCopied: false
    };
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _this2 = this;
      console.error("react error boundary - ".concat(error.message), error, errorInfo);
      // Catch errors in any components below and re-render with error message
      this.setState({
        error: error === null || error === void 0 ? void 0 : error.message,
        errorInfo: errorInfo
      }, function () {
        _logrocket["default"].track("uiError", {
          error: _this2.state.error
        });
        _logrocket["default"].captureMessage("uiError: ".concat(_this2.state.error), {
          tags: {
            error: _this2.state.error
          },
          extra: _this2.state.errorInfo
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (this.state.errorInfo) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
          align: "center",
          justify: "center",
          css: {
            size: "100%",
            color: "$textPrimary",
            backgroundColor: "$bgPrimary"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
            css: {
              position: "relative",
              overflow: "hidden",
              r: "$3",
              size: "100%"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
              direction: "column",
              css: {
                position: "absolute",
                size: "100%",
                top: "33.33%",
                left: 0
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                style: {
                  margin: "1.5rem"
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                  children: "Something went wrong. ERROR: ".concat(this.state.error)
                }), (0, _PreviewScreen.ErrorWithSupportLink)("Please reload to see if it works.")]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
                justify: "center",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
                  title: "Reload page",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
                    onClick: function onClick() {
                      window.location.reload();
                    },
                    css: {
                      mx: "$4"
                    },
                    "data-testid": "join_again_btn",
                    children: "Reload"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
                  title: "Copy error details to clipboard",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Button, {
                    onClick: function onClick() {
                      var _this3$state = _this3.state,
                        error = _this3$state.error,
                        errorInfo = _this3$state.errorInfo;
                      navigator.clipboard.writeText(JSON.stringify({
                        error: error,
                        errorInfo: errorInfo
                      }));
                      _this3.setState({
                        isErrorCopied: true
                      });
                    },
                    css: {
                      mx: "$4"
                    },
                    "data-testid": "join_again_btn",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CopyIcon, {}), " ", this.state.isErrorCopied ? "Copied" : "Copy Details"]
                  })
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("details", {
                style: {
                  whiteSpace: "pre-wrap",
                  margin: "1.5rem"
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                  children: this.state.error && this.state.error.toString()
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                  children: JSON.stringify(this.state.errorInfo)
                })]
              })]
            })
          })
        });
      }
      return this.props.children;
    }
  }]);
  return ErrorBoundary;
}(_react.Component);
exports.ErrorBoundary = ErrorBoundary;